import { ColumnType } from "../../types/dataGridTypes";

const useEnrollmentColumns = () => {
  const columns: ColumnType[] = [
    {
      field: "id",
      headerName: "Patient ID",
      minWidth: 120,
      flex: 1,
      cmp: "link",
      badge: true,
    },
    {
      field: "studyID",
      headerName: "Study ID",
      minWidth: 160,
      flex: 1,
      cmp: "link",
    },
    {
      field: "siteID",
      headerName: "Site ID",
      minWidth: 120,
      flex: 1,
      cmp: "link",
    },
    {
      field: "cancerType",
      headerName: "Cancer Type",
      minWidth: 120,
      flex: 1,
    },
    {
      field: "enrollDate",
      headerName: "Enrolled Date",
      minWidth: 120,
      flex: 1,
    },
    {
      field: "actionsColumn",
      width: 90,
      type: "actions",
      cmp: "actions",
      headerName: "Action",
      sortable: false,
      filterable: false,
      actionsArray: [
        { icon: "Edit", label: "Edit", key: "action_edit" },
        { icon: "Delete", label: "Delete", key: "action_delete" },
      ],
    },
  ];

  return columns;
};

export default useEnrollmentColumns;
